<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <!--<h2 style="text-align:center;background-color:#eeeeee;">{{ $t('Disaster Data Management') }}</h2>-->
    
    <material-card
      icon="mdi-weather-lightning"
      icon-small
      title="Event"
      color="accent"
    >
      <v-data-table v-if="disasters.length === 0" no-data :no-data-text="$t('No data available')"></v-data-table>
      <v-data-table 
        v-if="disasters.length !== 0"
        class="disaster-table"
        :headers="headers"
        :items="disasters" 
      >
 
      <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
        <span>{{ getHeader(header.text) }}</span>
      </template>

        <template v-slot:item.name_en="{ item }">
          <div>{{ getTranslation(item.disaster_category.translation.name) }} {{ item.year.name }}</div>
        </template>
        
       <!--<template v-slot:item.year="{ item }">
           <div >{{ getTranslation(item.year.name) }}</div>
        </template>-->

        <template v-slot:item.province="{ item }">
          <div v-for="(prov,province_id) in item.disaster_provinces" :key="prov.province_id">{{ getTranslation(prov.province.translation.name) }}</div>
        </template>
        <template v-slot:item.district="{ item }">
          <div v-for="(dist,district_id) in item.disaster_districts" :key="dist.district_id">{{ getTranslation(dist.district.translation.name) }} ( {{ getTranslation(dist.district.province.translation.name) }} )</div>
        </template>
        <template v-slot:item.village="{ item }">
          <div v-for="(vill,village_id) in item.disaster_villages" :key="vill.village_id">{{ getTranslation(vill.village.translation.name) }} ( {{ getTranslation(vill.village.district.province.translation.name) }},  {{ getTranslation(vill.village.district.province.translation.name) }} ) </div>
        </template>

        <!--<template v-slot:item.asset="{ item }">
          <div v-for="(ass,asset_id) in item.affected_assets" :key="ass.asset_id">
            <span v-if="ass.asset_type_id === 1">{{ ass.affected_road.road_referential.name_en }} ({{ getTranslation(ass.asset_type.translation.name) }})</span>
          </div>
        </template>

        <template v-slot:item.people="{ item }">
          <div v-if="item.total_affected_people">{{ item.total_affected_people.toLocaleString() }} {{ $t('people') }}</div>
          <div v-if="item.total_affected_woman">{{ item.total_affected_woman.toLocaleString() }} {{ $t('women') }}</div> 
          <div v-if="item.total_affected_family">{{ item.total_affected_family.toLocaleString() }} {{ $t('household') }}</div>
          <div v-if="item.total_death">{{ item.total_death.toLocaleString() }} {{ $t('death') }}</div>
        </template>

        <template v-slot:item.cost="{ item }">
          <div>{{ item.cost.toLocaleString() }}</div>
        </template>-->

        <template v-slot:item.details="{ item }">
            <v-btn class="small" color="success" v-on:click="viewModal(item)">
              <v-icon>mdi-book-open-blank-variant</v-icon>
            </v-btn>
        </template>

        <template v-slot:item.drop="{ item }">
          <v-btn v-if="item.project_needs.length === 0 && $store.state.auth.user.user_functions[3].user_type_id === 3" class="small" color="primary" v-on:click="drop('Disaster', item.name_en, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template slot="body.append">
            <tr>
                <th style="text-align:center;">{{ $t('Total') }}</th>
                <th style="text-align:center;">{{disasters.length}} {{ $t('Disasters') }}</th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
        </template>

      </v-data-table>

      <v-dialog v-model="dialog_view" max-width="1700px" :retain-focus="false">
        <DisasterForm 
          v-if="dialog_view" 
          :disasterProps="disaster_details" 
          :formType="'viewForm'" 
          :dialog.sync="dialog_view" />
      </v-dialog>
      <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
        <DeleteForm 
            v-if="dialog_delete" 
            :type="modal.type" 
            :name="modal.name" 
            :element="modal.element" 
            :dialog.sync="dialog_delete" 
            @deleteMessage="getAnswer" />
      </v-dialog>

    </material-card>

    <v-row style="height: 0; position: fixed; bottom: 10%; right: 0%;" v-if="$store.state.auth.user.user_functions[3].user_type_id !== 1">
        <v-dialog v-model="dialog_add" persistent max-width="1700px" :retain-focus="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="blue" v-bind="attrs" v-on="on" dark absolute right fab>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <DisasterForm 
            v-if="dialog_add" 
            :disasterProps="{}" 
            :formType="'addForm'" 
            :dialog.sync="dialog_add" />
        </v-dialog>
      </v-row> 

      <v-dialog v-model="$store.state.messages.confirmationMessageAdd" persistent max-width="800px" :retain-focus="false">
        <MessageAlert 
              v-if="$store.state.messages.confirmationMessageAdd" 
              :messageProps="$store.state.messages.validation_add" 
              :validationProps="$store.state.messages.ok" 
              :dialog.sync="$store.state.messages.confirmationMessageAdd" 
          />
      </v-dialog>
      
      <v-dialog v-model="$store.state.messages.confirmationMessageUpdate" persistent max-width="800px" :retain-focus="false">
        <MessageAlert 
              v-if="$store.state.messages.confirmationMessageUpdate" 
              :messageProps="$store.state.messages.validation_update" 
              :validationProps="$store.state.messages.ok" 
              :dialog.sync="$store.state.messages.confirmationMessageUpdate" 
          />
      </v-dialog>
      
      <v-dialog v-model="$store.state.messages.confirmationMessageDelete" persistent max-width="800px" :retain-focus="false">
        <MessageAlert 
              v-if="$store.state.messages.confirmationMessageDelete" 
              :messageProps="$store.state.messages.confirm_deletion" 
              :validationProps="$store.state.messages.ok" 
              :dialog.sync="$store.state.messages.confirmationMessageDelete" 
          />
      </v-dialog>

  </v-container>

</template>

<script>
  //import axios from 'axios'
  export default {
    name: 'DisasterMgtTable',
   /*props: {
      year: {
        type: Number
      }
     
    },*/
    data: () => ({
      headers: [
        {
          sortable: true,
          text: 'Event',
          align: 'center',
          value: 'name_en',
        },
        /*{
          sortable: true,
          text: 'Year',
          align: 'center',
          value: 'year',
          width: '4%'
        },*/
        {
          sortable: true,
          text: 'Province',
          align: 'center',
          value: 'province',
        },
        {
          sortable: true,
          text: 'District',
          align: 'center',
          value: 'district',
        },
        /*{
          sortable: true,
          text: 'Village',
          align: 'center',
          value: 'village',
        },*/
        {
          sortable: false,
          text: 'Details',
          align: 'center',
          value: 'details'
        },
        {
          sortable: false,
          text: 'Delete',
          align: 'center',
          value: 'drop'
        }
      ],
      //disasterResult : [],
      dialog_view: false,
      dialog_add: false,
      dialog_delete: false,
      deleteMessage: false,
      disaster_details: {},
      modal: {
        type:'',
        name:'',
        element_id: 0 //{ disaster_id: 0 }
      }
    }),
    computed: {
        disasters() {
          return this.$store.state.disasters.disasters;
        },
        /*totalCost() {
          return this.disasters.reduce((acc, obj) => {
            return acc + obj.cost;
          }, 0);
        }*/
    },
    mounted: function(){
      this.$store.dispatch('disasters/getDisasters');
      console.log(this.disasters);
      //this.getDisasterFiltered(this.disasters);
    },
    /*watch: {
      dialog_view: function(){
        this.$store.dispatch('disasters/getDisasters');
      },
      dialog_add: function(){
        this.$store.dispatch('disasters/getDisasters');
      },
      dialog_update: function(){
        this.$store.dispatch('disasters/getDisasters');
      },
      dialog_delete: function(){
        this.$store.dispatch('disasters/getDisasters');
      },
      year: function(years){
        this.year = years;
        this.getDisasterFiltered(years);
      },
      disasters: function() {
          if(this.$store.state.disasters.disasters.length !== 0){
            this.getDisasterFiltered(0);
          }
        }
    },*/

    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      viewModal: function(disaster){
        this.disaster_details = disaster;
        this.dialog_view = true;        
      },
      drop: function(type, name, disaster_id){
        this.dialog_delete = true;
        this.modal.type = type;
        this.modal.name = name;
        this.modal.element_id = disaster_id;
        //this.modal.element.disaster_id = disaster_id;
      },
      getAnswer(value){
        if(value){
          this.$store.dispatch('disasters/deleteDisaster',this.modal.element_id);
        }
      },
      /*getDisasterFiltered(year){
        var disTemp =[];
 
        if(year !== 0){
          this.disasters.forEach(function(dis) {
            if(dis.year.name === year){
              disTemp.push(dis);
            }
        
          });
         this.disasterResult = disTemp;
         
        }
         else{
          this.disasterResult = this.disasters;
        }  
       
       
      }*/

    },
     
  }
</script>
<style scoped>
  .v-data-table::v-deep tbody tr:nth-child(odd) {
    background-color: white; /* Odd rows */
  }

  .v-data-table::v-deep tbody tr:nth-child(even) {
    background-color: #F0F0F0; /* Even rows */
  }
  .disaster-table > .v-data-table__wrapper > table > tbody > tr > td,
  .disaster-table > .v-data-table__wrapper > table > tbody > tr > th, 
  .disaster-table > .v-data-table__wrapper > table > thead > tr > td, 
  .disaster-table > .v-data-table__wrapper > table > thead > tr > th, 
  .disaster-table > .v-data-table__wrapper > table > tfoot > tr > td, 
  .disaster-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 5px;
  }
  .small {
    width: 40px;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 40px;
  }
  .v-btn {
    position: relative;
  }
  .add-button {
    justify-content: flex-end;
  }
  /*.disaster-table > .v-data-table__wrapper > table > tbody > tr:nth-child(odd) {
    background-color: white;
  }
   .disaster-table > .v-data-table__wrapper > table > tbody > tr:nth-child(even) {
    background-color: black;
  }*/

</style>
